/**
 * HOME LANGUAGE SURVEY APPLICATION
 *
 * Main entry point for the Vermont Agency of Education's Home Language Survey application.
 * This React application helps schools collect and process home language information from students
 * to identify potential English Learners for Title III compliance.
 *
 * Key Features:
 * - Multi-language survey form with validation
 * - Azure AD authentication integration
 * - Survey processing and management tools
 * - Student search and comparison functionality
 * - PDF generation and export capabilities
 * - Language crosswalk and ISO 639-3 support
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/custom_bootstrap_theme.css'
import './styles/additionalStyles.css'
import { msalInstance, initializeMsal } from './component/shared/MsalInstanceProvider'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { MsalProvider } from '@azure/msal-react'

// Configure axios default headers for CORS and authentication
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

// Set up bearer token authentication if user is already logged in
/*if (localStorage.getItem('msalIdToken') != null) {
  axios.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${localStorage.getItem('msalIdToken')}`
}*/

import { routeTree } from './routeTree'
import Page_404 from './Page_404'

// Create the application router with defined route tree
const router = createRouter({
  routeTree,
  defaultNotFoundComponent: Page_404,
})

// Initialize MSAL and render the application
// MSAL must be initialized before any authentication operations
const root = ReactDOM.createRoot(document.getElementById('content'))

initializeMsal()
  .then(() => {
    root.render(
      <MsalProvider instance={msalInstance}>
        <RouterProvider router={router} />
      </MsalProvider>
    )
  })
  .catch(error => {
    console.error('Failed to initialize MSAL:', error)
    root.render(
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h3>Authentication Initialization Error</h3>
        <p>Failed to initialize authentication. Please refresh the page.</p>
        <button onClick={() => window.location.reload()}>Refresh Page</button>
      </div>
    )
  })
